// ** Reducers Imports
import layout from './layout'
import navbar from './navbar'
import connectionPoints from './connectionPoints'
import auth from './auth'
import linkStaff from './linkStaff'
import school from './school'
import connectionPointsTable from './connectionPointsTable'
import positionMap from './positionMap'
import proyects from './proyects'
import documents from './documents'
import catalogs from './catalogs'
import digitalMagazine from './digitalMagazine'
import users from './users'
import notifications from './notifications'
import workgroups from './workgroups'
import groups from './groups'
import reports from './reports'

const rootReducer = {
    navbar,
    layout,
    connectionPoints,
    auth,
    linkStaff,
    connectionPointsTable,
    school,
    positionMap,
    proyects,
    documents,
    catalogs,
    digitalMagazine,
    users,
    notifications,
    workgroups,
    groups,
    reports
}

export default rootReducer
